module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-layout', {
    attrs: {
      "ResizeCallback": _vm.resize
    }
  }, [_c('div', {
    staticClass: "tabContainer"
  }, [_c('div', {
    ref: "vizContainer",
    style: ({
      'height': this.reportHeight + 'px',
      'min-height': this.reportMinHeight + 'px',
      'overflow-x': 'auto',
      'overflow-y': 'hidden'
    }),
    attrs: {
      "id": "vizContainer"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-438a9d40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tableau.vue
// module id = 480
// module chunks = 2